module.exports = __webpack_public_path__ + "assets/img/Back_logo.ae3e8a5d-ps.jpg";